import angular from 'angular';
import moment from 'moment';
import { BillableRegistration } from '../model/billableRegistration';
import { guid1 } from '@/shared/utils/guid';

angular.module('cloudX').directive('cxDraftInvoiceRow', function() {
  return {
    restrict: 'E',
    template: require('./draftInvoiceRow.html'),
    scope: {
      invoice: '=',
      hiddenColumns: '=',
      reloadInvoice: '&',
      gotoInvoice: '&',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: [
      '$filter',
      'resourceFactorySvc',
      'dataCache',
      'dialogsSvc',
      'flySvc',
      'invoiceDialogsSvc',
      'appMessages',
      'appInsights',
      '$q',
      '$timeout',
      '$translate',
      'invoiceStreamNamesSvc',
      function(
        $filter,
        resourceFactorySvc,
        dataCache,
        dialogsSvc,
        flySvc,
        invoiceDialogsSvc,
        appMessages,
        appInsights,
        $q,
        $timeout,
        $translate,
        invoiceStreamNamesSvc,
      ) {
        var vm = this;
        var draftInvoiceLineResource = resourceFactorySvc.get('invoiceLine');
        var invoiceRegistrationResource = resourceFactorySvc.get('invoiceRegistration');
        vm.datepickerOptions = {
          startingDay: 1,
          initDate: moment
            .utc()
            .startOf('day')
            .toDate(),
        };
        vm.currentUser = dataCache.getArray('employee');
        vm.users = dataCache.getObject('user');
        vm.$onInit = function() {
          vm.showAssignments =
            dataCache.getArray('assignmentsEnabled') &&
            vm.invoice?.invoiceLines?.some(x => x.invoiceStreamId !== vm.invoice.invoiceStreamId);
          vm.customerStreams = null;
          if (vm.showAssignments && vm.invoice?.customer?.id) {
            invoiceStreamNamesSvc.get(vm.invoice.customer.id).then(function(streams) {
              vm.customerStreams = streams || [];
            });
          }
        };

        //Invoice line actions
        vm.addInvoiceLine = function() {
          invoiceDialogsSvc.newDraftInvoiceLine(vm.invoice).then(function(result) {
            vm.processServerResult(result, null, null);
            var idx = vm.invoice.invoiceErrors.findIndex(function(el) {
              return el.code === 11026;
            });
            if (idx >= 0) vm.invoice.invoiceErrors.splice(idx, 1);
          });
        };

        const deleteInvoiceLineRequest = function(line, neverInvoice = false) {
          return draftInvoiceLineResource.delete(
            {
              id: vm.invoice.id,
              invoiceLineId: line.id,
              neverInvoice,
            },
            null,
            function(result) {
              vm.processServerResult(result, line, null);
            },
            vm.showError,
          ).$promise;
        };

        vm.deleteInvoiceLine = function(line) {
          if (line.type === 6) {
            //SettledAdvance, postpone to next billing period/invoice
            return invoiceDialogsSvc
              .deleteWithNeverInvoice('comfirmUndoOrNeverSettledAdvanceLine', 'neverSettleAdvance')
              .then(function(neverInvoice) {
                return deleteInvoiceLineRequest(line, neverInvoice);
              });
          }
          if (!vm.invoice.status && line.hasRegistrations) {
            //Line has registrations, provide never invoice option
            return invoiceDialogsSvc
              .deleteWithNeverInvoice('comfirmUndoOrNeverInvoiceLine')
              .then(function(neverInvoice) {
                return deleteInvoiceLineRequest(line, neverInvoice);
              });
          }
          //Show normal delete confirm for all other types
          return dialogsSvc
            .showYesNo('comfirmDeleteTitle', 'comfirmDeleteInvoiceLine')
            .then(function() {
              return deleteInvoiceLineRequest(line, false);
            });
        };

        vm.undoLine = function(line) {
          draftInvoiceLineResource.reset(
            {
              id: vm.invoice.id,
              id2: line.id,
            },
            null,
            function(result) {
              vm.processServerResult(result, line, null);
            },
          );
        };

        vm.updateLineVatRate = function(line, vatRate, vatType) {
          if (line.billedVatRate === vatRate && line.billedVatType === vatType) return false;
          var model = angular.copy(line);

          model.vatRate = vatRate;
          model.vatType = vatType;
          return draftInvoiceLineResource
            .update(
              {
                id: vm.invoice.id,
              },
              model,
            )
            .$promise.then(function(result) {
              vm.processServerResult(result, line, null);
              return false;
            }, vm.showError);
        };

        vm.saveLine = function(line, prop, value) {
          //Called from outside somewhere...
          if (!line || !prop || typeof line[prop] === 'undefined') return '';
          if (prop === 'discountPercentage') {
            if (Math.abs(value) > 1) {
              flySvc.error(10015, ['0', '100']);
              return '';
            } else if (value < 0) flySvc.message('msgNegativeDiscountWarning');
          }
          if (prop === 'quantity' && value !== null) {
            if (vm.invoice.isInvoice && value < 0) {
              flySvc.message('Attention: an amount in an invoice is usually positive');
            } else if (!vm.invoice.isInvoice && value > 0) {
              flySvc.message('Attention: an amount in a credit note is usually negative');
            }
          }
          if (line[prop] === value) return false;
          var model = angular.copy(line);
          model[prop] = value;

          return draftInvoiceLineResource
            .update(
              {
                id: vm.invoice.id,
              },
              model,
            )
            .$promise.then(function(result) {
              vm.processServerResult(result, line, null);
              return false;
            }, vm.showError);
        };

        vm.moveLine = function(line, up) {
          if (!line || !line.id) return false;
          return draftInvoiceLineResource.move(
            {
              id: vm.invoice.id,
              id2: line.id,
              up: !!up,
            },
            null,
            function(data) {
              if (data.length !== 2) return;
              var line2;
              if (data[0].id === line.id) {
                line.nr = data[0].nr;
                line2 = data[1];
              } else {
                line.nr = data[1].nr;
                line2 = data[0];
              }

              var line3 = vm.invoice.invoiceLines.find(function(el) {
                return el.id === line2.id;
              });
              if (line3) line3.nr = line2.nr;
            },
            vm.showError,
          );
        };

        vm.toggleDetails = function(line) {
          if (!line.hasRegistrations) return;
          if (!line.registrations) {
            line.registrations = [];
            draftInvoiceLineResource.registrations(
              { id: vm.invoice.id, invoiceLineId: line.id },
              function(registrations) {
                line.registrations = registrations;
                line.showRelation =
                  registrations &&
                  registrations.some(r => r.invoiceStreamId !== vm.invoice.invoiceStreamId);

                line.showDetails = !line.showDetails;
              },
            );
          } else {
            line.showDetails = !line.showDetails;
          }
        };

        //Invoice detail registration actions
        vm.addDetailLine = function(line) {
          line.newDetailLines = line.newDetailLines || [];
          if (line.registrations.length) {
            var first = line.registrations[0];
            line.newDetailLines.push(
              new BillableRegistration({
                userId: vm.currentUser.userID,
                date: new Date(),
                customer: first.customer,
                type: first.type,
                resourceId: first.resourceId,
                resource: first.resource,
                originalQuantity: 0.0,
                originalUnitPrice: first.billedUnitPrice(),
                originalDiscountPercentage: first.billedDiscountPercentage(),
                originalVatRate: first.billedVatRate(),
                originalVatType: first.billedVatType(),
                remark: '',
                internalRemark: '',
                quantity: 1.0,
                unitPrice: first.billedUnitPrice(),
                discountPercentage: first.billedDiscountPercentage(),
                price: first.currentPrice(),
                vatRate: first.billedVatRate(),
                vatType: first.billedVatType(),
                originalBillable: false,
                billable: true,
                invoiceStreamId: line.invoiceStreamId,
                originalInForfait: first.originalInForfait,
                inForfait: first.inForfait,
              }),
            );
            line.showDetails = true;
          }
        };

        vm.toggleBillable = function(line, detail) {
          vm.saveDetailLine(
            line,
            detail,
            'billable',
            detail.billable == null ? !detail.originalBillable : !detail.billable,
          );
        };

        vm.validateDetailLine = function(detail) {
          if (typeof detail.quantity === 'undefined') return false;
          if (detail.quantity === 0) return false;
          if (typeof detail.discountPercentage === 'undefined') return false;
          if (detail.discountPercentage < 0 || detail.discountPercentage > 1) return false;
          if (detail.unitPrice < 0) return false;
          return true;
        };

        vm.submitDetailLine = function(line, detail) {
          if (!vm.validateDetailLine(detail)) return;
          invoiceRegistrationResource.create(
            {
              invoiceId: vm.invoice.id,
            },
            detail,
            function(result) {
              var idx = line.newDetailLines.indexOf(detail);
              if (idx >= 0) line.newDetailLines.splice(idx, 1);
              vm.processServerResult(result, line, detail);
            },
            vm.showError,
          );
        };

        const deleteDetailLineRequest = (line, detail, neverInvoice = false) => {
          return invoiceRegistrationResource.delete(
            {
              invoiceId: vm.invoice.id,
              id: detail.id,
              neverInvoice,
            },
            null,
            function(result) {
              vm.processServerResult(result, line, detail);
            },
            vm.showError,
          ).$promise;
        };
        vm.deleteDetailLine = function(line, detail) {
          if (!detail.id) {
            var idx = line.newDetailLines.indexOf(detail);
            if (idx >= 0) line.newDetailLines.splice(idx, 1);
            line.billedQuantity -= detail.billedQuantity();
            return;
          }

          if (!!vm.invoice.status || (detail.source === 1 && vm.invoice.invoiceType !== 6)) {
            //Show normal delete if this is a numbered invoice or this is a billing registration
            dialogsSvc
              .showYesNo(
                'comfirmDeleteTitle',
                detail.source === 1
                  ? 'comfirmDeleteInvoiceDetailLine'
                  : 'comfirmUndoInvoiceDetailLine',
              )
              .then(function() {
                deleteDetailLineRequest(line, detail, false);
              });
          } else {
            invoiceDialogsSvc
              .deleteWithNeverInvoice('comfirmUndoOrNeverInvoiceDetailLine')
              .then(function(neverInvoice) {
                deleteDetailLineRequest(line, detail, neverInvoice);
              });
          }
        };

        vm.undoDetailLine = function(line, detail) {
          detail.undo();
          vm.saveDetailLine(line, detail);
        };
        vm.updateDetailVatRate = function(line, detail, vatRate, vatType) {
          if (!line || !detail) return '';
          if (detail.billedVatRate() === vatRate && detail.billedVatType() === vatType)
            return false;
          var model = angular.copy(detail);
          if (detail.originalVatRate === vatRate && detail.originalVatType === vatType) {
            model.vatRate = null;
            model.vatType = null;
          } else {
            model.vatRate = vatRate;
            model.vatType = vatType;
          }

          return invoiceRegistrationResource
            .update(
              {
                invoiceId: vm.invoice.id,
              },
              model,
            )
            .$promise.then(function(result) {
              vm.processServerResult(result, line, detail);
              return false;
            }, vm.showError);
        };

        vm.saveDetailLine = function(line, detail, field, value) {
          var model;
          if (!line || !detail) return '';
          if (typeof field !== 'undefined' && field !== null) {
            if (typeof detail[field] === 'undefined') return '';
            if (field === 'discountPercentage') {
              if (Math.abs(value) > 1) {
                flySvc.error(10015, ['0', '100']);
                return '';
              } else if (value < 0) flySvc.message('msgNegativeDiscountWarning');
            }

            if (field === 'quantity' && value !== null) {
              if (vm.invoice.isInvoice && value < 0) {
                flySvc.message('Attention: an amount in an invoice is usually positive');
              } else if (!vm.invoice.isInvoice && value > 0) {
                flySvc.message('Attention: an amount in a credit note is usually negative');
              }
            }
            if (field === 'date' && !value) return '';

            if (detail[field] === value) return false;
            model = angular.copy(detail);
            model[field] = value;
          } else {
            //Save without checking if value changed
            model = angular.copy(detail);
          }
          if (model.date instanceof Date) model.date = model.date.ISO();
          try {
            if (!!vm.invoice.status && appInsights)
              appInsights.trackEvent(
                { name: 'InvoiceDetailUpdatedOnNumberedInvoice' },
                {
                  lineId: line.id,
                  detailId: detail.id,
                  field,
                  newValue: JSON.stringify(model[field]),
                  oldValue: JSON.stringify(detail[field]),
                },
              );
          } catch (e) {
            //ignore
          }

          return invoiceRegistrationResource
            .update(
              {
                invoiceId: vm.invoice.id,
              },
              model,
            )
            .$promise.then(function(result) {
              vm.processServerResult(result, line, detail);
              return false;
            }, vm.showError);
        };

        vm.resourceChanged = function(line, detail, resource) {
          if (!resource || !resource.id) return '';
          if (!line || !detail) return '';
          if (detail.resourceId === resource.id) return false;
          return invoiceRegistrationResource
            .changeResource(null, {
              id: detail.id,
              resourceId: resource.id,
            })
            .$promise.then(function(result) {
              vm.processServerResult(result, line, detail);
              return false;
            }, vm.showError);
        };

        vm.getUserName = function(userId) {
          if (!userId) return '';
          if (userId === guid1) return $translate.instant('SystemUser');
          if (!vm.users) vm.users = dataCache.getObject('user') || {};
          var user = vm.users[userId];
          if (!user) return '';
          return ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
        };

        vm.processServerResult = function(result, line, registration) {
          var emptyGuid = '00000000-0000-0000-0000-000000000000';

          vm.invoice.baseAmount = result.baseAmount;
          vm.invoice.vatAmount = result.vatAmount;
          vm.invoice.totalExclusive = result.totalExclusive;
          vm.invoice.totalInclusive = result.totalInclusive;
          vm.invoice.exForfaitAmount = result.exForfaitAmount;
          vm.invoice.originalAmount = result.originalAmount;
          vm.invoice.adjustedAmount = result.adjustedAmount;
          vm.invoice.modifiedDate = result.modifiedDate;

          if (result.updatedLines != null && result.updatedLines.length > 0) {
            for (var i = 0; i < result.updatedLines.length; i++) {
              var line2 = vm.invoice.findLine(result.updatedLines[i].id);
              if (line2 == null) {
                line2 = result.updatedLines[i];
                if (line2.registrations.length) line2.showDetails = true;
                vm.invoice.addLine(line2);
              } else {
                line2.update(result.updatedLines[i]);
              }
            }
          }

          if (result.deletedRegistrationId != null && result.deletedRegistrationId !== emptyGuid) {
            if (angular.isDefined(line) && typeof line === 'string')
              line = vm.invoice.findLine(line);

            if (line) {
              line.deleteRegistration(result.deletedRegistrationId);
              line.billedQuantity = line.billedQuantity - registration.billedQuantity();
              line.showDetails = true;
            }
          }

          if (result.deletedLine != null && result.deletedLine !== emptyGuid) {
            vm.invoice.deleteLine(result.deletedLine);
          }
          if (result.otherInvoiceId != null && result.otherInvoiceId !== emptyGuid) {
            if (vm.reloadInvoice)
              $q.when(vm.reloadInvoice({ invoiceId: result.otherInvoiceId })).then(() => {
                if (vm.gotoInvoice) {
                  flySvc.action(
                    'msgRegistrationMovedToOtherDraftInvoice',
                    'msgClickToOpenDraftInvoice',
                    function() {
                      vm.gotoInvoice({ invoiceId: result.otherInvoiceId, expand: true });
                    },
                  );
                } else {
                  flySvc.info('msgRegistrationMovedToOtherDraftInvoice');
                }
              });
          }

          vm.invoice.discountType = result.discountType;
          vm.invoice.discountAmount = result.discountAmount;

          if (result.billingErrors) {
            const billingErrors = JSON.parse(result.billingErrors);
            vm.invoice.parseBillingErrors(billingErrors);
          } else {
            vm.invoice.parseBillingErrors([]);
          }
        };

        vm.updateRegistrationRelation = function(line, detail) {
          if (!detail.id || detail.source === 1) return;
          if (!!vm.invoice.status) return;

          invoiceDialogsSvc.updateRegistrationRelation(detail, true).then(function(result) {
            if (result) vm.processServerResult(result, line, detail);
          });
        };

        vm.showError = function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          return '';
        };

        vm.resourcesCache = {};
        vm.getResourcesForType = function(type) {
          if (type > 2) return [];
          if (typeof vm.resourcesCache[type] !== 'undefined') return vm.resourcesCache[type];

          vm.resourcesCache[type] = resourceFactorySvc
            .get('resource')
            .reg({ type: type })
            .$promise.then(function(data) {
              vm.resourcesCache[type] = data.map(item => ({
                ...item,
                label: $filter('resourceName')(item),
                code: item.code || '',
              }));
              return vm.resourcesCache[type];
            });
          return vm.resourcesCache[type];
        };
        vm.getAssignmentName = function(line) {
          if (!line.invoiceStreamId) return '';
          if (typeof line.assignmentName === 'string') return line.assignmentName;
          if (!vm.customerStreams) return ''; //Streams not loaded yet; don't memoize

          const invoiceStream = vm.customerStreams.find(x => x.id === line.invoiceStreamId);
          line.assignmentName = invoiceStream
            ? $filter('invoiceStreamName')(invoiceStream, '')
            : '';

          return line.assignmentName;
        };

        vm.openTaskDetail = function(detail) {
          vm.taskDetail = { id: detail.plannedTaskId };
        };

        vm.closeTaskDetail = function() {
          $timeout(() => {
            vm.taskDetail = null;
          }, 0);
        };
      },
    ],
  };
});
